import { ReactElement, useRef, ComponentPropsWithRef } from "react";
import { usePopoverLegacyContext } from "./usePopoverLegacyContext";
import { useMergeRefs } from "../../hooks";

type PopoverLegacyTriggerDataType = {
  "data-state": "open" | "closed";
} & ComponentPropsWithRef<any>;

export type PopoverLegacyTriggerProps = {
  children: (data: PopoverLegacyTriggerDataType) => ReactElement;
};

export const PopoverLegacyTrigger = function PopoverLegacyTrigger(
  props: PopoverLegacyTriggerProps,
) {
  const { children } = props;
  const context = usePopoverLegacyContext();
  const ref = useRef(null);
  const mergedRef = useMergeRefs([context.refs.setReference, ref]);

  return children({
    "data-state": context.open ? "open" : "closed",
    "data-anv": "popover-trigger",
    ...context.getReferenceProps({ ref: mergedRef }),
  });
};
